import L from 'leaflet'


function patchDrawToolbarSaveMethod(saveHandler) {
  L.DrawToolbar.include({
    getActions: function (handler) {
      return [
        {
          // enabled: this._customSaveHandler.bind(this),
          enabled: true,
          title: L.drawLocal.draw.toolbar.finish.title,
          text: L.drawLocal.draw.toolbar.finish.text,
          callback: this._customSaveHandler.bind(this),
          context: handler
        },
        {
          enabled: handler.deleteLastVertex,
          title: L.drawLocal.draw.toolbar.undo.title,
          text: L.drawLocal.draw.toolbar.undo.text,
          callback: handler.deleteLastVertex,
          context: handler
        },
        {
          title: L.drawLocal.draw.toolbar.actions.title,
          text: L.drawLocal.draw.toolbar.actions.text,
          callback: this.disable,
          context: this
        }
      ];
    },

    _customSaveHandler: function () {
      const handler = this._activeMode.handler;
      let layer = new handler.Poly(handler._poly.getLatLngs(), handler.options.shapeOptions);
      this._activeMode.handler.completeShape();

      saveHandler({layer, layerType: handler.type});
    },

  });
}

function patchEditToolbarSaveMethod(saveHandler, removeAllLayersEnabled) {
  L.EditToolbar.include({
    getActions: function (handler) {
      let actions = [
        {
          title: L.drawLocal.edit.toolbar.actions.save.title,
          text: L.drawLocal.edit.toolbar.actions.save.text,
          callback: this._customSaveHandler,
          context: this
        },
        {
          title: L.drawLocal.edit.toolbar.actions.cancel.title,
          text: L.drawLocal.edit.toolbar.actions.cancel.text,
          callback: this._cancel,
          context: this
        }
      ];

      if (removeAllLayersEnabled && handler.removeAllLayers) {
        actions.push({
          title: L.drawLocal.edit.toolbar.actions.clearAll.title,
          text: L.drawLocal.edit.toolbar.actions.clearAll.text,
          callback: this._clearAllLayers,
          context: this
        });
      }

      return actions;
    },

    _customSaveHandler: function () {
      const handler = this._activeMode.handler;
      let changedLayers = [];

      if(handler.type === 'edit') {
        changedLayers = this._getEditedLayers();
      } else if(handler.type === 'remove') {
        changedLayers = this._getDeletedLayers();
      }

      saveHandler(
        {type: handler.type, layers: changedLayers},
        this._save.bind(this),
        this._cancel.bind(this),
      );
    },

    _getEditedLayers() {
      let editedLayers = [];
      this.options.featureGroup.eachLayer(function (layer) {
        if (layer.edited) {
          editedLayers.push(layer);
        }
      });
      return editedLayers;
    },

    _getDeletedLayers() {
      let layers = [];
      this._activeMode.handler._deletedLayers.eachLayer(layer => {
        layers.push(layer);
      });

      return layers;
    },

    _save: function () {
      this._activeMode.handler.save();
      if (this._activeMode) {
        this._activeMode.handler.disable();
      }
    },

    _cancel: function() {
      this.disable();
      this._map.fire('draw:editcancel');
    },
  });
}

export {
  patchDrawToolbarSaveMethod,
  patchEditToolbarSaveMethod,
}